// services/EnglishService.ts
import { TopicResponse } from "./EnglishModel";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:7845"; // Express backend

export async function fetchTopics(params: {
  id?: string;
  name?: string;
  description?: string;
  page: number;
  limit: number;
  sortBy?: string;
  order?: "asc" | "desc";
}): Promise<TopicResponse> {
  const query = new URLSearchParams();

  // filters
  if (params.id) query.append("id", params.id);
  if (params.name) query.append("name", params.name);
  if (params.description) query.append("description", params.description);

  // sorting
  if (params.sortBy) query.append("sortBy", params.sortBy);
  if (params.order) query.append("order", params.order);

  // pagination
  query.append("page", params.page.toString());
  query.append("limit", params.limit.toString());

  const res = await fetch(`${API_URL}/api/english-topics?${query.toString()}`);

  if (!res.ok) {
    throw new Error("Failed to fetch topics");
  }

  return res.json();
}
